import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Students.Data.StudentParentData[]> {
  return axios.get(route('api.student-parents.search', filters)).then((res) => res.data);
}
